import { gql } from '@apollo/client';
import { CbPromoCodeFields } from './fragments';

export const CREATE_CB_PROMO_CODE = gql`
  mutation CreateCbPromoCode($input: CreateCbPromoCodeInput!) {
    createCbPromoCode(input: $input) {
      ...CbPromoCodeFields
    }
  }
  ${CbPromoCodeFields}
`;

export const UPDATE_CB_PROMO_CODE = gql`
  mutation UpdateCbPromoCode($input: UpdateCbPromoCodeInput!) {
    updateCbPromoCode(input: $input) {
      ...CbPromoCodeFields
    }
  }
  ${CbPromoCodeFields}
`;
